import { render, staticRenderFns } from "./newdocment.vue?vue&type=template&id=467b4b8a&scoped=true"
import script from "./newdocment.vue?vue&type=script&lang=js"
export * from "./newdocment.vue?vue&type=script&lang=js"
import style0 from "./newdocment.vue?vue&type=style&index=0&id=467b4b8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467b4b8a",
  null
  
)

export default component.exports